import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Swal from "sweetalert2";
import MainLayout from "../../../components/layout/MainLayout";
import Breadcrumbs from "../../../components/common/Breadcrumbs";
import FamilyMeetingMinutesForm from "./FamilyMeetingMinutesForm";
import { createFamilyMeetingMinute } from "../../../store/slices/familyMeetingMinutesSlice";
import { fetchPatient } from "../../../store/slices/patientsSlice"; // Added this import

const AddFamilyMeetingMinutes = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { isLoading, error } = useSelector((state) => state.familyMeetingMinutes);
    const { state } = useLocation();
    const { caseId, patientId } = state || {};

    const [errors, setErrors] = useState({});
    const [prefilledName, setPrefilledName] = useState(""); // ⭐ ADD THIS LOCAL STATE VARIABLE

    // ⭐ ADD THIS PATIENT FETCHING HOOK BLOCK ⭐
    useEffect(() => {
        if (patientId) {
            dispatch(fetchPatient(patientId))
                .unwrap()
                .then((patient) => {
                    if (patient) {
                        const fullName = `${patient.first_name || ""} ${patient.last_name || ""}`.trim();
                        setPrefilledName(fullName);
                    }
                })
                .catch((err) => console.error("Failed to fetch patient for meeting minutes:", err));
        }
    }, [dispatch, patientId]);

    const handleSubmit = async (formData) => {
        // Convert camelCase → snake_case
        const payload = {
            patient_id: formData.patientId || patientId || null,
            case_id: formData.caseId || caseId || null,
            client_name: formData.clientName,
            report_written_by: formData.reportWrittenBy,
            date: formData.date,
            family_members: formData.familyMembers.map((m) => ({ name: m.name })),
            team_members: formData.teamMembers.map((m) => ({ name: m.name })),
            agenda: formData.agendaOfMeeting,
            summary: formData.summaryOfDiscussion,
            action_plan: formData.actionPlanAgreedUpon,
        };

        // Frontend validation
        const newErrors = {};
        if (!payload.client_name) newErrors.client_name = "Client name is required.";
        if (!payload.report_written_by) newErrors.report_written_by = "Report written by is required.";
        if (!payload.date) newErrors.date = "Date is required.";

        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
            Swal.fire({
                title: "Missing Fields",
                text: "Please fill in all required fields.",
                icon: "warning",
                confirmButtonText: "OK",
            });
            return;
        }

        try {
            await dispatch(createFamilyMeetingMinute(payload)).unwrap();

            Swal.fire({
                title: "Success!",
                text: "Family meeting minutes added successfully.",
                icon: "success",
                timer: 2000,
                showConfirmButton: false,
            });

            navigate(`/cases/${payload.case_id}/profile`, { state: { patientId: payload.patient_id, caseId: payload.case_id } });
        } catch (err) {
            console.error("Create error:", err);
            setErrors(err?.errors || {});
            Swal.fire({
                title: "Error",
                text: err?.message || "Failed to save record.",
                icon: "error",
            });
        }
    };

    return (
        <MainLayout>
            <div className="container-xxl flex-grow-1 container-p-y">
                <Breadcrumbs />

                <div className="card">
                    <div className="card-body">
                        {/* API Error */}
                        {error && (
                            <div className="alert alert-danger">
                                <strong>Error:</strong> {error}
                            </div>
                        )}

                        {/* Validation Errors */}
                        {Object.keys(errors).length > 0 && (
                            <div className="alert alert-danger">
                                {Object.entries(errors).map(([key, value], i) => (
                                    <div key={i}>
                                        {Array.isArray(value) ? value.join(", ") : value}
                                    </div>
                                ))}
                            </div>
                        )}

                        <form
                            onSubmit={(e) => {
                                e.preventDefault();
                                const form = e.target;
                                const formData = form.__formData__;
                                if (formData) handleSubmit(formData);
                            }}
                        >
                            <FamilyMeetingMinutesForm
                                initialData={{
                                    clientName: prefilledName,
                                    patientId,
                                    caseId
                                }} // ⭐ PASS PREFILLED DETAILS HERE
                                onChange={(data) => {
                                    const form = document.querySelector("form");
                                    if (form) form.__formData__ = data;
                                }}
                            />

                            <div className="col-12 d-flex justify-content-end mt-4">
                                <div className="col-md-2 d-flex justify-content-end">
                                    <button
                                        type="submit"
                                        className="btn btn-primary px-4"
                                        disabled={isLoading}
                                    >
                                        {isLoading ? (
                                            <>
                                                <i className="ri-loader-4-line me-1 animate-spin"></i> Saving...
                                            </>
                                        ) : (
                                            <>
                                                <i className="ri-save-3-line me-1"></i> Save
                                            </>
                                        )}
                                    </button>
                                </div>
                            </div>
                        </form>

                    </div>
                </div>
            </div>
        </MainLayout>
    );
};

export default AddFamilyMeetingMinutes;